import { render, staticRenderFns } from "./list-PendingReview.vue?vue&type=template&id=5b977f53&"
import script from "./list-PendingReview.vue?vue&type=script&lang=js&"
export * from "./list-PendingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports